module.exports = __webpack_public_path__ + "img/drapeau.652e377c.png";